import React, { useState } from 'react'
import axios from 'axios';

import { API } from '../backend';

const Testchatbot = () => {
    const [userInput, setUserInput] = useState("");
  const [chatLog, setchatLog] = useState([])

  const displayUserMessage = (message) => {
    const userMessage = { sender: 'user', text: message};
    setchatLog(prevChatLog => [...prevChatLog, userMessage]);
  };
  const displayBotMessage = (message, buttons) => {
    const botMessage = { sender: 'bot_reply', text: message, button: buttons };
    setchatLog(prevChatLog => [...prevChatLog, botMessage]);
  };

  const sendMessageToRasa = async (message) => {
    const config = {
      headers: { 'content-type': 'multipart/form-data' }
    }
    const response = await axios.post(`${API}chat/chat_with_bot/`,
      {
        user_message: message
      },
      config,
    )
    const data = await response.data;
    if (data.bot_reply) {
      displayBotMessage(data.bot_reply, data.choice);
    }
  };

  const handleButtonPayload = (payload) => {
      sendMessageToRasa(payload);
  };

  const handleSendMessage = async (event) => {
    if (event.keyCode === 13) {
      const message = userInput.trim();
      if (message !== "") {
        displayUserMessage(message);
        sendMessageToRasa(message);
        setUserInput("");
      }
    }
  }

  return (
    <div>
    <div className="container containerm " >
      <>
        <div className="chat-icon"
        >
          Ask Athena
        </div>
        <div className="chatbox" >
          <div className="chatbox-header">
            Athena
            <span className="close-icon cursor-pointer"
            >
              <i className="fa fa-times"></i>
            </span>
          </div>
          <div className="chatbox-body">
            {chatLog.map((message) => (
              <p
                className={`chatbox-message ${message.sender === "user" ? "sent" : "received"
                  }`}
              >
                {message.text === undefined ?
                  "" :
                  <span className="message-content">{message.text}</span>
                }
                {message.button && message.button.length !== 0 && (
                  <div className="button-container">
                    {message.button.map((button, buttonIndex) => (
                      <button
                        key={buttonIndex}
                        onClick={() => handleButtonPayload(button)}
                      >
                        {button}
                      </button>
                    ))}
                  </div>
                )}
                {message.list && message.list.length > 0 && (
                  <ul className="bot-list message-content">
                    {message.list.map((item, itemIndex) => (
                      <li className="forlistchatbot" key={itemIndex}>{item}</li>
                    ))}
                  </ul>
                )}
              </p>
            ))}
          </div>
          <div className="chatbox-controls">
            <input
              type="text"
              className="chatbox-input"
              placeholder="Type your message..."
              value={userInput}
              onChange={(event) => setUserInput(event.target.value)}
              onKeyDown={handleSendMessage}
            />
          </div>
        </div>
      </>
    </div>
  </div>
  )
}

export default Testchatbot